import { render, staticRenderFns } from "./PurchaseListDialog.vue?vue&type=template&id=285703c3&scoped=true"
import script from "./PurchaseListDialog.vue?vue&type=script&lang=js"
export * from "./PurchaseListDialog.vue?vue&type=script&lang=js"
import style0 from "./PurchaseListDialog.vue?vue&type=style&index=0&id=285703c3&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285703c3",
  null
  
)

export default component.exports